import {
    SYSTEM_SUBMIT_USERTAG_BEGIN,
    SYSTEM_SUBMIT_USERTAG_SUCCESS,
    SYSTEM_SUBMIT_USERTAG_FAILURE,
    SYSTEM_SUBMIT_USERTAG_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitUserTag(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_USERTAG_BEGIN,
      });
  
      let apiurl = '/api/b/userTag/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/userTag/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_USERTAG_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_USERTAG_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitUserTagError() {
    return {
      type: SYSTEM_SUBMIT_USERTAG_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_USERTAG_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitUserTagPending: true,
          submitUserTagError: null,
        };
  
      case SYSTEM_SUBMIT_USERTAG_SUCCESS:
        // The request is success
        return {
          ...state,
          submitUserTagPending: false,
          submitUserTagError: null,
        };
  
      case SYSTEM_SUBMIT_USERTAG_FAILURE:
        // The request is failed
        return {
          ...state,
          submitUserTagPending: false,
          submitUserTagError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_USERTAG_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitUserTagError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitUserTag.js